<template>
  <div class="big-graph-unit">
    <div class="big-graph">
      <div class="big-graph-bar">
        <div
          class="big-graph-bar-fill big-graph-bar-fill--primary"
          v-bind:style="{ width: firstBarWitdth + '%' }"
        ></div>
      </div>
      <div class="big-graph-desc">
        <h4>Current Workforce</h4>
        <div class="price">{{ data[0] | currency({ fractionCount: 0 }) }}</div>
      </div>
    </div>
    <div class="big-graph big-graph--secondary">
      <div class="big-graph-bar">
        <div
          class="big-graph-bar-fill big-graph-bar-fill--secondary"
          v-bind:style="{ width: secondBarWidth + '%' }"
        ></div>
      </div>
      <div class="big-graph-desc">
        <h4>5 year older Workforce</h4>
        <div class="price">{{ data[1] | currency({ fractionCount: 0 }) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoeDoubleHorizontalBar",
  props: {
    data: {
      type: Array[Number],
      required: true
    },
    labels: {
      type: Array[String],
      required: false
    },
    maxValue: {
      type: Number,
      required: true
    }
  },
  computed: {
    firstBarWitdth() {
      return (this.data[0] / this.maxValue) * 100;
    },
    secondBarWidth() {
      return (this.data[1] / this.maxValue) * 100;
    }
  }
};
</script>
